'use client'

import { ChipLink } from '@sim/emcn'
import { useTranslations } from 'next-intl'

/**
 * A document navigation initializes the landing theme when leaving an app status page.
 *
 * omnyqra: UI language (Omnyqra/sim#49), see FORK.md
 */
export function ReturnHomeLink() {
  const t = useTranslations('errors.common')
  return (
    <ChipLink
      variant='primary'
      href='/'
      prefetch={false}
      onNavigate={(event) => {
        event.preventDefault()
        window.location.assign('/')
      }}
    >
      {t('returnHome')}
    </ChipLink>
  )
}
